module.exports = __webpack_public_path__ + "img/stone-path-u.7d568feb.png";